import View from './MainMenu'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const MainMenu = connect(mapStateToProps)(View)

export default MainMenu
